import { useTranslation } from "react-i18next";

export const NoItemsMessage = ({
  title,
  message,
}: {
  title: string;
  message: string;
}) => {
  const { t } = useTranslation();
  return (
    <div className="mt-12 text-center">
      <p className="text-lg font-medium">{t(title)}</p>
      <p className="text-sm mt-1">{t(message)}</p>
    </div>
  );
};
